import { render, staticRenderFns } from "./ModalCreateSupplier.vue?vue&type=template&id=67ee8b59"
import script from "./ModalCreateSupplier.vue?vue&type=script&lang=js"
export * from "./ModalCreateSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports